<template>
  <PageContainer :title="$t('tuan-dui-guan-li')">
    <template #pageTop>
      <div class="flex-y-center justify-between">
        <div class="flex-y-center gap-2 text-16 mb-[26px] min-h-[28px]">
          <span class="font-medium text-font-1">
            {{ $t('tuan-dui-ming-cheng') }}：
          </span>
          <ChangeName
            :title="$t('tuan-dui-ming-cheng')"
            type="team"
            :name="userInfo?.organization_name!"
            :editable="hasActionPermission('center_member_change_team_name')"
          />
          <span v-if="enableLogoEdit" class="pl-[60px] font-medium">
            {{ $t('tuan-dui-logo') }}：
          </span>
          <CustomLogo v-if="enableLogoEdit" />
          <XUserVerify
            v-if="checkPermission(ActionListKey.COMPANY_VERIFY)"
            :status="userInfo?.identify_info?.status"
            :disabled="
              !checkPermission(ActionListKey.GO_COMPANY_VERIFY) ||
              !hasActionPermission('center_account_change_verify_info')
            "
          />
        </div>
        <ClientOnly>
          <a-dropdown
            v-if="
              isTeam &&
              !isGlobalVersion() &&
              hasActionPermission('center_member_cancellation')
            "
          >
            <a-button
              type="default"
              class="text-primary flex-y-center justify-center"
            >
              <template #icon>
                <iconpark-icon name="zhuxiao" size="16"></iconpark-icon>
              </template>
            </a-button>
            <template #overlay>
              <a-menu>
                <a-menu-item>
                  <a @click="showDeleteModal">{{ $t('zhu-xiao-tuan-dui') }}</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </ClientOnly>
      </div>
    </template>
    <template #pageExtra>
      <NoSeat v-if="showNoSeat" />
      <template v-else>
        <AddMemberLink
          v-if="hasActionPermission('center_member_add_team_member_by_link')"
        />
        <a-button
          v-else-if="
            hasActionPermission('center_member_add_team_member_by_normal')
          "
          type="primary"
          @click="openCreateOrEdit"
        >
          {{ $t('tian-jia-cheng-yuan') }}
        </a-button>
        <!-- <AddMemberCreateOrEdit
          v-else-if="
            hasActionPermission('center_member_add_team_member_by_normal')
          "
          v-model:open="addOrEditMemberOpen"
          v-model:type="addOrEditMemberType"
          :data="addOrEditMemberData"
          @reload="reload"
        /> -->
      </template>
    </template>
    <a-table
      :columns="columns"
      :data-source="list"
      :loading="loading"
      :pagination="pagination"
      :scroll="{ y: 'calc(100vh - 320px)' }"
      @change="handleTableChange"
    >
      <template #bodyCell="{ column, text, record }">
        <div v-if="column.key === 'permission'">
          {{ useDictItem('roles', text)?.label }}
        </div>
        <div v-else-if="column.key === 'create_time'">
          {{ timeFormat(text, 'YYYY.MM.DD') }}
        </div>
        <div v-else-if="column.key === 'phone_number'">
          {{ !record.is_kicked_user ? text : '******' }}
        </div>
        <div v-else-if="column.key === 'username'">
          {{ getUserAccount(record as Member) }}
        </div>
        <div v-else-if="column.key === 'action'" class="flex gap-2">
          <template v-if="record.is_active_user">
            <template
              v-if="
                record.permission === USER_ADMIN.ORG_ADMIN_USER &&
                hasActionPermission('center_member_transfer_administrator')
              "
            >
              <a @click="changeAdmin(record)">
                {{ $t('zhuan-rang') }}
              </a>
              <a
                v-if="
                  !hasActionPermission('center_member_add_team_member_by_link')
                "
                @click="editMember(record as Member)"
              >
                {{ $t('bian-ji') }}
              </a>
              <a
                v-if="
                  !hasActionPermission('center_member_add_team_member_by_link')
                "
                @click="resetPassword(record as Member)"
              >
                {{ $t('zhong-zhi-mi-ma') }}
              </a>
            </template>
            <template v-else>
              <a v-if="!record.is_kicked_user" @click="kick(record as Member)">
                {{ $t('yi-chu') }}
              </a>
              <a v-else @click="restore(record as Member)">
                {{ $t('hui-fu') }}
              </a>
              <a
                v-if="
                  hasActionPermission(
                    'center_member_show_team_member_login_account'
                  ) && !record.is_kicked_user
                "
                @click="editMember(record as Member)"
              >
                {{ $t('bian-ji') }}
              </a>
              <a
                v-if="
                  hasActionPermission(
                    'center_member_show_team_member_login_account'
                  ) && !record.is_kicked_user
                "
                @click="resetPassword(record as Member)"
              >
                {{ $t('zhong-zhi-mi-ma') }}
              </a>
            </template>
            <a
              v-if="hasActionPermission('center_member_manage_team_member')"
              @click="purchase(record as Member)"
            >
              {{ $t('shi-yong-ming-xi') }}
            </a>
          </template>
          <template v-else>
            <a @click="restore(record as Member)">
              {{ $t('hui-fu') }}
            </a>
            <a-popover trigger="hover" placement="top" width="200">
              <template #content>
                <div class="w-[300px]">
                  {{
                    $t(
                      'you-yu-tuan-dui-xi-wei-bu-zu-gai-xi-wei-xian-zan-ting-shi-yong-qing-lian-xi-guan-li-yuan'
                    )
                  }}
                </div>
              </template>
              <a-tag color="#f50" style="cursor: pointer">
                {{ $t('yi-guo-qi-dong-jie') }}
              </a-tag>
            </a-popover>
          </template>
        </div>
      </template>
      <template #emptyText>
        <EmptyView :class="{ invisible: loading }" />
      </template>
    </a-table>
    <AddMemberCreateOrEdit
      v-model:open="addOrEditMemberOpen"
      v-model:type="addOrEditMemberType"
      :data="addOrEditMemberData"
      @reload="reload"
    />
  </PageContainer>
</template>
<script lang="ts" setup>
import type { TableProps } from 'ant-design-vue'
import AddMemberLink from './components/addMemberLink.vue'
import AddMemberCreateOrEdit from './components/memberCreateOrEdit.vue'
import Purchase from './components/purchase.vue'
import SignalTurn from './components/signalTurn.vue'
import { formColumns as getFormColumns } from './components/change'
import CustomLogo from './components/custom-logo.vue'
import NoSeat from './components/noSeat.vue'
import ChangeName from '@/features/changeName/index.vue'
import { checkPermission, ActionListKey } from '@/utils/permission'
import { useDictItem } from '@/utils/dict'
import {
  getMembers,
  kickMembers,
  changeTeamAdmin,
  restoreMembers,
  reinviteMembers,
  getUserAccountList,
} from '~/api'
import { usePage } from '~/hooks/usePage'
import { useDefaultModal } from '~/hooks/useModal/modals/defaultModal'
import { useConfirm } from '~/hooks/useModal/modals/confirm'
import { showDeleteAccount } from '~/hooks/useModal/modals/deleteAccount'
import { USER_ADMIN } from '~/constants'
import { useForm } from '~/features/form'
import { USER_LEVEL_KEY, type Member } from '~/api/interface'
import { isGlobalVersion } from '~/utils/area'
import { useTime } from '~/hooks/useTime'
import { BROADCAST_KEY, COOKIE_KEY } from '~/constants/config'

const formColumns = getFormColumns()
const userInfo = useUserInfo()
const { $t } = useNuxtApp()
const { timeFormat } = useTime()
const addOrEditMemberOpen = ref(false)
const addOrEditMemberType = ref<'createAccount' | 'editName' | 'resetPassword'>(
  'createAccount'
)
const addOrEditMemberData = ref<Member>()

const { hasActionPermission } = usePageAndActionPermissionData()

const columns = [
  {
    title: $t('cheng-yuan-xing-ming'),
    dataIndex: 'account_name',
    key: 'account_name',
  },
  {
    title: $t('jiao-se'),
    dataIndex: 'permission',
    key: 'permission',
  },
  {
    title: $t('jia-ru-shi-jian'),
    dataIndex: 'create_time',
    key: 'create_time',
  },
  {
    ...(hasActionPermission('center_member_show_team_member_login_account')
      ? {
          title: $t('deng-lu-zhang-hao-0'),
          dataIndex: 'username',
          key: 'username',
        }
      : !isGlobalVersion()
      ? {
          title: $t('dian-hua-hao-ma'),
          dataIndex: 'phone_number',
          key: 'phone_number',
        }
      : {
          title: $t('you-xiang'),
          dataIndex: 'email_address',
          key: 'email_address',
        }),
  },
  {
    title: $t('yan-bi-xiao-hao'),
    dataIndex: 'used_credit_coins',
    key: 'used_credit_coins',
  },
  {
    title: $t('cun-chu-kong-jian-shi-yong'),
    dataIndex: 'used_storage',
    key: 'used_storage',
    customRender: ({ text }: any) => getFormateFileSize(text || 0, false),
  },
  {
    title: $t('cao-zuo'),
    key: 'action',
  },
]

const pageSize = 24
const { list, total, page, page_size, loading, getList, reload } = usePage({
  api: (params) =>
    getMembers({
      ...params,
      is_active_user: 2,
    }),
  pageSize,
})

// 历史数据is_edit_logo，现在用权限配置
const enableLogoEdit = computed(
  () =>
    userInfo.value?.is_edit_logo ||
    hasActionPermission('center_member_logo_config')
)

const isTeam = computed(
  () =>
    [USER_LEVEL_KEY.TEAM_LIGHT, USER_LEVEL_KEY.TEAM_TASTE].includes(
      userInfo.value!.rights_type
    ) && userInfo.value!.permission !== USER_ADMIN.NORMAL
)

const showNoSeat = computed(() => {
  return (
    userInfo.value?.rights.sub_account_num === 0 || userInfo.value?.is_expired
  )
})

const getUserAccount = (record: Member) => {
  if (record.email_address) {
    return record.email_address
  }
  if (record.phone_number?.indexOf('-') === -1) {
    return record.phone_number
  }
  return record.username
}

const pagination = computed(() => ({
  total: total.value,
  current: page.value,
  pageSize: page_size.value,
}))

const handleTableChange: TableProps['onChange'] = (p) => {
  page.value = p.current as number
  page_size.value = p.pageSize as number
  getList({ page: p.current, page_size: p.pageSize })
}

const showDeleteModal = () => {
  trackEvent(TRACK_EVENT.LOG_OFF_ACCOUNT)
  showDeleteAccount(logout, DELETE_TYPE.TEAM)
}

function editMember(record: Member) {
  addOrEditMemberData.value = record
  addOrEditMemberType.value = 'editName'
  addOrEditMemberOpen.value = true
}

function openCreateOrEdit() {
  // addOrEditMemberData.value = {}
  addOrEditMemberType.value = 'createAccount'
  addOrEditMemberOpen.value = true
}

function resetPassword(record: Member) {
  addOrEditMemberData.value = record
  addOrEditMemberType.value = 'resetPassword'
  addOrEditMemberOpen.value = true
}

const permissionData = usePermissionData()

// 退出登录
const logout = async () => {
  trackEvent(TRACK_EVENT.LOGIN_OUT_CLICK)
  await useLoginOut()
  // emitBroadcast(COOKIE_KEY.USER_TOKEN, {
  //   cookieValue: undefined,
  // })
  emitBroadcast(BROADCAST_KEY.REFRESH, { tabId: TAB_ID })
  if (permissionData.value?.config?.logout_url && import.meta.client) {
    location.href = permissionData.value?.config?.logout_url
  }
}

const leftSubAccountNum = computed(() => {
  return userInfo.value?.rights?.sub_account_num || 0
})

const restore = (record: Member) => {
  if (leftSubAccountNum.value <= 0) {
    return message.error($t('xi-wei-bu-zu-qing-yi-chu-cheng-yuan-hou-cao-zuo'))
  }
  useConfirm({
    icon: true,
    title: $t('hui-fu-recordaccountname-cheng-yuan', [record.account_name]),
    description: $t(
      'hui-fu-recordaccountname-cheng-yuan-hou-recordaccountname-jiang-zhong-xin-jia-ru-tuan-dui-que-ren-hui-fu',
      [record.account_name, record.account_name]
    ),
    okText: $t('hui-fu'),
    onOk: async () => {
      trackEvent(TRACK_EVENT.CLICK_RESTORE_TO_TEAM, {
        team_id: userInfo.value?.organization_id,
        team_name: userInfo.value?.organization_name,
        members_id: record.account_name,
        members_name: record.account_name,
        operator_id: userInfo.value?.user_id,
        operator_name: userInfo.value?.account_name,
      })
      if (record.is_kicked_user) {
        await reinviteMembers({ user_id: String(record.user_id) })
      } else if (!record.is_active_user) {
        await restoreMembers({ user_id: String(record.user_id) })
      }
      await useUpdateUser()
      message.success($t('hui-fu-cheng-gong'))
      reload()
    },
  })
}

const kick = (record: Member) => {
  useConfirm({
    icon: true,
    title: $t('yi-chu-recordaccountname-cheng-yuan', [record.account_name]),
    description: $t(
      'yi-chu-recordaccountname-cheng-yuan-hou-qi-zai-tuan-dui-xiang-mu-zhong-chuang-zuo-de-xiang-guan-zuo-pin-cheng-pian-mo-ban-zhi-jie-gui-shu-dao-chao-ji-guan-li-yuan-yi-chu-hou-wu-fa-che-xiao-que-ren-shi-fou-yi-chu',
      [record.account_name]
    ),
    okText: $t('yi-chu'),
    onOk: async () => {
      trackEvent(TRACK_EVENT.KICK_FROM_TEAM, {
        team_id: userInfo.value?.organization_id,
        team_name: userInfo.value?.organization_name,
        members_id: record.account_name,
        members_name: record.account_name,
        operator_id: userInfo.value?.user_id,
        operator_name: userInfo.value?.account_name,
      })
      await kickMembers({ account_id: record.account_id })
      await useUpdateUser()
      message.success($t('yi-chu-cheng-gong'))
      reload()
    },
  })
}

const purchase = (record: Member) => {
  trackEvent(TRACK_EVENT.CLICK_MEMBER_USE_DETAIL, {
    team_id: userInfo.value?.organization_id,
    team_name: userInfo.value?.organization_name,
    members_id: record.account_name,
    members_name: record.account_name,
    operator_id: userInfo.value?.user_id,
    operator_name: userInfo.value?.account_name,
  })

  useDefaultModal({
    title: $t('shi-yong-ming-xi'),
    width: 982,
    footer: false,
    content: h(
      'div',
      { class: 'p-[16px_16px_0] h-[700px] overflow-hidden' },
      h(Purchase, {
        userId: record.user_id,
        record: {
          ...record,
          rights: userInfo.value?.rights,
        },
        scrollY: isGlobalVersion() ? '360px' : '390px',
      })
    ),
  })
}

const getMemberOptions = async () => {
  const { data, code } = await getMembers({
    ignore_kicked: true,
    many: 1,
    is_active_user: 2,
  })
  if (code !== 0) {
    return []
  }

  return data
    ?.filter((item: any) => item.permission === USER_ADMIN.NORMAL)
    .map((item: any) => ({
      label: item.account_name,
      value: item.account_id,
    }))
}

const changeAdmin = async (record: Record<string, any>) => {
  const options = await getMemberOptions()
  const userInfo = useUserInfo()
  if (formColumns[3].inputAttrs) {
    formColumns[3].inputAttrs.options = options
  }

  const { validate, modelRef, View } = useForm(formColumns)
  modelRef.name = record.account_name
  modelRef.phone = record.phone_number
  modelRef.email = record.email_address

  if (!options?.length) {
    useDefaultModal({
      title: $t('zhuan-rang-guan-li-yuan'),
      width: 500,
      content: h(SignalTurn, { info: userInfo }),
      okText: $t('zhi-dao-le'),
      noCancelBtn: true,
    })
  } else {
    useDefaultModal({
      title: $t('zhuan-rang-guan-li-yuan'),
      width: 500,
      content: h('div', { class: 'p-[16px_50px]' }, [
        h(
          'div',
          {
            class:
              'bg-warning-6 bg-opacity-20 p-[10px_12px] rounded-[8px] text-12 text-font-80 mb-[30px]',
          },
          [
            h('span', { class: 'text-error mr-[2px]' }, '*'),
            h(
              'span',
              { class: 'text-font-80' },
              $t(
                'zhuan-rang-hou-nin-jiang-cheng-wei-cheng-yuan-shi-qu-suo-you-chao-ji-guan-li-yuan-quan-xian-qie-bu-zhi-chi-che-xiao'
              )
            ),
          ]
        ),
        h(View),
      ]),
      okText: $t('que-ren-zhuan-rang'),
      onOk: async () => {
        await validate()
        await changeTeamAdmin({
          account_id: modelRef.account_id,
          sms_code: modelRef.code,
          ...(isGlobalVersion()
            ? {
                email: modelRef.email,
              }
            : {
                mobile: modelRef.phone,
              }),
        })

        trackEvent(TRACK_EVENT.TRANSFER_ADMINISTRATOR_SUCCESS, {
          team_id: userInfo.value?.organization_id,
          team_name: userInfo.value?.organization_name,
          members_id_before: userInfo.value?.user_id,
          members_name_before: userInfo.value?.account_name,
          members_id_after: record.user_id,
          members_name_after: record.account_name,
        })

        message.success($t('zhuan-rang-cheng-gong'))
        window.location.href = `${location.origin}/platform/`
      },
    })
  }
}

reload()

onMounted(() => {
  trackEvent(TRACK_EVENT.PAGE_TEAM_MANEGE, {
    team_id: userInfo.value?.organization_id,
    team_name: userInfo.value?.organization_name,
    operator_id: userInfo.value?.user_id,
    operator_name: userInfo.value?.account_name,
  })
})
</script>
<style lang="scss" scoped></style>
